<script>
    import store from '../../../assets/src/Stores/auth-store';
    import {goto} from '@sveltech/routify';

    store.logout();
    $goto('/login');
</script>